import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useModalContext } from "../Reactportal/ModalContext";
import "./HeaderDiv.scss";
import IconsDiv from "./HeaderDivComponents/IconsDiv/IconsDiv";
import SearchBoxesDiv from "./HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { memo, useEffect } from "react";

function HeaderDiv({
  title,
  PageType,
  func,
  closeFun,
  TableKey = "",
  Children,
  IsDateSearchShow = true,
  isShowFromDateSearch = true,
  MoreActions = {},
  MoreIcons = [],
}) {
  const { pushModal, clearModalStack, setCurrentTitle } = useModalContext();
  const dispatch = useDispatch();
  // console.log(TableKey, "TableKeyTableKeyTableKey");
  useEffect(() => {
    // console.log(TableKey);
    if (TableKey) {
      dispatch({ type: "CLEAR_ALL_COMPONENT_PROP" });
      clearModalStack();
      setCurrentTitle(TableKey);
      pushModal(TableKey);
    }
  }, [TableKey]);

  return (
    <div className="header_div">
      <IconsDiv
        title={title}
        PageType={PageType}
        func={func}
        closeFun={closeFun}
        TableKey={TableKey}
        MoreActions={MoreActions}
        MoreIcons={MoreIcons}
      />
      <>{Children}</>
      {title && IsDateSearchShow && <SearchBoxesDiv isShowFromDateSearch={isShowFromDateSearch} />}
    </div>
  );
}

export default memo(HeaderDiv);

HeaderDiv.propTypes = {
  PageType: PropTypes.string || PropTypes.func,
  title: PropTypes.string, // This prop is optional
  func: PropTypes.func,
  closeFun: PropTypes.func,
  Children: PropTypes.any,
  MoreActions: PropTypes.object,
  MoreIcons: PropTypes.any,
};

HeaderDiv.defaultProps = {
  PageType: "",
  func: () => {},
  closeFun: () => {},
  Children: <></>,
  MoreActions: {},
  MoreIcons: []
};
